export default __webpack_public_path__ + "static/media/suggestion-chips-dialog0.b2a9c1b0.png";